import { gql, useApolloClient, useMutation } from '@apollo/client';
import { asNull } from '@everlutionsk/helpers';

export function useSignOut() {
  const [signOut] = useMutation(mutation);
  const apollo = useApolloClient();

  return async () => {
    await signOut().catch(asNull);

    apollo.cache.evict({
      id: 'ROOT_QUERY',
      fieldName: 'adminIdentity'
    });

    window.location.href = '/auth';
  };
}

const mutation = gql<SignOutGQL>`
  mutation SignOut {
    signOut
  }
`;
